<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="registration_semester_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('academic_year_of_registration')">
                            <semesters-selectbox
                                v-model="formData.registration_semester_id"
                                :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="registration_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('registration_date')">
                            <selectDate v-model="formData.registration_date"
                                        :validationError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="registration_type" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('registration_type')">
                            <parameter-selectbox v-model="formData.registration_type"
                                                 code="registration_types"
                                                 :student-type="formData.student_type"
                                                 :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="student_status" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('student_status')">
                            <parameter-selectbox v-model="formData.student_status"
                                                 code="student_statuses"
                                                 :student-type="formData.student_type"
                                                 :is-cache="false"
                                                 :filter-other-url="true"
                                                 :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4" v-if="['309','310'].includes(formData.student_status)">
                    <b-form-group :label="$t('transfer_out_destination')">
                        <ValidationProvider name="to_university_id" :rules="['107'].includes(formData.student_status)?'required':''" v-slot="{valid, errors}">
                            <university-selectbox v-model="formData.to_university_id"
                                                  :validate-error="errors[0]"
                            />
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="legal_presence_type" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('legal_presence_type')">
                            <parameter-selectbox code="legal_presence_types" v-model="formData.legal_presence_type"
                                                 :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="re_enrollment" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('re_enrollment')">
                            <yes-no-selectbox v-model="formData.re_enrollment"
                                              :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="reinstatement" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('reinstatement')">
                            <yes-no-selectbox v-model="formData.reinstatement"
                                              :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="program_path" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('program_path')">
                            <parameter-selectbox
                                v-model="formData.program_path"
                                code="program_paths"
                                :student-type="formData.student_type"
                                :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="esl_group" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('esl_group_name')">
                            <ParameterSelectbox code="esl_groups" v-model="formData.esl_group" :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="esl_placement_score" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('esl_placement_score')">
                            <b-form-input type="number" v-model="formData.esl_placement_score"
                                          :class="errors[0] ? 'is-invalid':''"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="placement_exam_level_id" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('placement_exam_test')">
                            <esl-level-selectbox type="number" v-model="formData.placement_exam_level_id"
                                                 :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="cefr_level" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('cefr_level')">
                            <parameter-selectbox v-model="formData.cefr_level"
                                                 code="cefr_levels"
                                                 :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="cefr_level_current" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('cefr_level_current')">
                            <parameter-selectbox v-model="formData.cefr_level_current"
                                                 code="cefr_levels"
                                                 :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="cefr_level_completed" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('cefr_level_completed')">
                            <parameter-selectbox v-model="formData.cefr_level_completed"
                                                 code="cefr_levels"
                                                 :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="academic_probation" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('academic_probation')">
                            <yes-no-selectbox v-model="formData.academic_probation"
                                                 :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="appeal_letter" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('appeal_letter')">
                            <select-date v-model="formData.appeal_letter"
                                              :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="4">
                    <ValidationProvider name="behavior_probation" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('behavior_probation')">
                            <parameter-selectbox v-model="formData.behavior_probation"
                                                 code="behavior_probation_types"
                                                 :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6" class="flex-column d-flex">
                    <div class="mb-2">
                        <h6 class="mb-0">{{ $t('graduation_information') }}</h6>
                    </div>
                    <div class="border rounded equal-height p-4 mb-4">

                        <ValidationProvider name="completion_decision_date"
                                            :rules="formData.student_status == '102' ? 'required':''"
                                            v-slot="{valid, errors}">
                            <b-form-group :label="$t('graduation_date')">
                                <selectDate v-model="formData.graduation_date"
                                            :validationError="errors[0]"
                                />
                            </b-form-group>

                        </ValidationProvider>
                    </div>
                </b-col>
                <b-col md="6" class="flex-column d-flex">
                    <div class="mb-2">
                        <h6 class="mb-0">{{ $t('leaving_information') }}</h6>
                    </div>
                    <div class="border rounded equal-height p-4 mb-4">
                        <ValidationProvider name="leaving_reason"
                                            rules=""
                                            v-slot="{valid, errors}">
                            <b-form-group :label="$t('reason_for_leaving')">
                                <parameter-selectbox v-model="formData.leaving_reason"
                                                     code="leaving_reasons"
                                                     :student-type="formData.student_type"
                                                     :validateError="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                        <ValidationProvider name="leaving_date" rules=""
                                            v-slot="{valid, errors}">
                            <b-form-group :label="$t('leaving_date')">
                                <selectDate v-model="formData.leaving_date"
                                            :validationError="errors[0]"
                                />
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center">
                <b-button variant="primary" @click="updateForm" :disabled="formProcess">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    // Services
    import StudentProgramService from '@/services/StudentProgramService'

    // Other
    import {ValidationObserver, ValidationProvider} from 'vee-validate'
    import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';
    import EslLevelSelectbox from "@/components/interactive-fields/EslLevelSelectbox.vue";
    import moment from "moment";
    import ProgramConcentrationsSelectbox from "@/components/interactive-fields/ProgramConcentrationsSelectbox.vue";
    import UniversitySelectbox from "@/components/interactive-fields/UniversitySelectbox.vue";
    import YesNoSelectbox from "@/components/interactive-fields/YesNoSelectbox.vue";

    export default {
        components: {
            YesNoSelectbox, UniversitySelectbox, ProgramConcentrationsSelectbox,
            ValidationProvider,
            ValidationObserver,

            ParameterSelectbox,
            EslLevelSelectbox
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            }
        },
        created() {
            this.formId = this.studentProgram.id;
            this.formData = this.studentProgram;
        },
        data() {
            return {
                formId: null,
                formData: {},
                formProcess: false
            }
        },
        methods: {
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {


                    this.formProcess = true;
                    StudentProgramService.updateMentora(this.formId,this.formData)
                                         .then(response => {
                                             this.$emit('updateFormSuccess', true);
                                             this.$toast.success(this.$t('api.' + response.data.message));
                                         })
                                         .catch(e => {
                                             this.showErrors(e, this.$refs.formModalValidate)
                                         })
                                         .finally(() => {
                                             this.formProcess = false
                                         })
                }
            }
        }
    }
</script>

